// extracted by mini-css-extract-plugin
var _1 = "DBBTI";
var _2 = "k14NU";
var _3 = "vW7j5";
var _4 = "rDNLF";
export { _1 as "searchFeedbackSecondRow", _2 as "searchFeedbackWithSort", _3 as "searchResultsText", _4 as "searchThumbsFeedbackSecondRow" }
